import simpleMessageHndb from './templates/simple-message.handlebars';
import { View } from '../seller/views/view';
import { Modal } from './modal';

export class SimpleMessage extends View {
    constructor({title, body, c2a, c2a_link}) {
        super(new Modal({maxWidth: '400px'}));
        this.content = simpleMessageHndb({title, body, c2a, c2a_link});
    }


    open = () => {
        this.view.update(this.content);
        this.view.open();
    }
}